export const BusinessEventType = {
    "POPUP": 1,
    "VIRTUAL": 2
  }